import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";

import { useAppTheme } from "../../theme/useAppTheme";

const GatewaySelectionDialog = ({ open, onClose, gateways }) => {
  const handleSelect = (gateway) => {
    onClose(gateway);
  };
  const themeColors = useAppTheme();

  return (
    <Dialog
      open={open}
      onClose={() => onClose(null)}
      PaperProps={{
        sx: {
          background: themeColors.bigContainer,
          color: themeColors.text,
          border: `1px solid ${themeColors.scaffold}`,
        },
      }}
    >
      <DialogTitle>Select Payment Gateway</DialogTitle>
      <DialogContent>
        <List>
          {gateways.map((gateway, index) => (
            <ListItem key={index}>
              <ListItemButton
                onClick={() => handleSelect(gateway)}
                sx={{
                  background: themeColors.mediumContainer,
                  color: themeColors.text,
                  border: `1px solid ${themeColors.scaffold}`,
                  borderRadius: 2,
                  mb: 1,
                  "&:hover": {
                    background: themeColors.svgColor,
                  },
                }}
              >
                <ListItemText
                  primary={gateway.toUpperCase()}
                  sx={{
                    "& .MuiListItemText-primary": {
                      color: themeColors.text,
                      fontWeight: 600,
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => onClose(null)}
          sx={{
            background: themeColors.primary,
            color: themeColors.text,
            border: `1px solid ${themeColors.scaffold}`,
            borderRadius: 2,
            mb: 1,
            "&:hover": {
              background: themeColors.svgColor,
            },
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GatewaySelectionDialog;
